import { render, staticRenderFns } from "./payback.vue?vue&type=template&id=0074d039&scoped=true&"
import script from "./payback.vue?vue&type=script&lang=js&"
export * from "./payback.vue?vue&type=script&lang=js&"
import style0 from "./payback.vue?vue&type=style&index=0&id=0074d039&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0074d039",
  null
  
)

export default component.exports